/** @flow */
import { startRequest, finishRequest } from "@store/utils";
import {
  ExportFocusListsDepartmentReport,
  ExportFocusListsDepartmentReportSuccess,
  GetReportingFocusListsDepartmentReport,
  GetReportingFocusListsDepartmentReportSuccess,
  GetReportingFocusListsDepartmentReportError,
  SetFocusListsDepartmentReportViewState,
  GetFocusListDepartmentReportProfile,
  GetFocusListDepartmentReportProfileSuccess,
} from "@modules/reporting/constants/actions";
import { LOCATION_CHANGE } from "connected-react-router";
import type { ReportState, DepartmentReportViewState } from "./types";
import { cloneObject } from "@utils/object";

export const initialViewState: DepartmentReportViewState = {
  selectedDepartment: null,
  absenceProfileExpanded: true,
  departmentFocusListExpanded: true,
  departmentResultsExpanded: true,
};

export const initialState = {
  requestsInProgress: 0,
  reportGenerateInProgress: 0,
  error: null,
  details: null,
  reportData: null,
  effectiveParameters: null,
  charts: {
    focusList: null,
  },
  viewState: initialViewState,
  departmentProfile: {
    absenceRatePerMonth: [],
    daysLostPerEmployeeByGender: [],
    daysLostPerEmployeeByAgeGroup: [],
    top5AbsenceReasonsByWorkingDaysLost: [],
    top10EmployeesByWorkingDaysLost: [],
  },
};

export const setLoading = (state: ReportState) => () => startRequest(state);

export const onGetReportingFocusListsDepartmentReportSuccess = (state: ReportState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  canSave: payload.canSave,
  details: payload.details,
  reportData: payload.reportData,
  effectiveParameters: payload.effectiveParameters,
  charts: {
    ...state.charts,
    focusList: payload.focusList,
  },
});

const onExportFocusListsDepartmentReport = (state: ReportState) => () => ({
  ...state,
  reportGenerateInProgress: ++state.reportGenerateInProgress,
});

const onExportFocusListsDepartmentReportSuccess = (state: ReportState) => () => ({
  ...state,
  reportGenerateInProgress:
    state.reportGenerateInProgress > 0 ? --state.reportGenerateInProgress : 0,
});

const onGetReportingFocusListsDepartmentReportError = (state: ReportState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload.error,
});

export const onSetViewState = (state: ReportState) => ({ payload }: Object) => ({
  ...state,
  viewState: {
    ...state.viewState,
    ...payload,
  },
});

export const onResetViewState = (state: ReportState) => () => ({
  ...state,
  viewState: initialViewState,
});

export const onGetFocusListDepartmentReportProfileSuccess = (state: ReportState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  departmentProfile: {
    ...payload,
  },
});

export default (state: ReportState = initialState, action: Object): ReportState => {
  const act = {
    [ExportFocusListsDepartmentReport]: onExportFocusListsDepartmentReport,
    [ExportFocusListsDepartmentReportSuccess]: onExportFocusListsDepartmentReportSuccess,
    [GetReportingFocusListsDepartmentReport]: setLoading,
    [GetReportingFocusListsDepartmentReportSuccess]: onGetReportingFocusListsDepartmentReportSuccess,
    [GetReportingFocusListsDepartmentReportError]: onGetReportingFocusListsDepartmentReportError,
    [SetFocusListsDepartmentReportViewState]: onSetViewState,
    [LOCATION_CHANGE]: onResetViewState,
    [GetFocusListDepartmentReportProfile]: setLoading,
    [GetFocusListDepartmentReportProfileSuccess]: onGetFocusListDepartmentReportProfileSuccess,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
